export interface IScore {
    lifetime: number
}
export class Score {
    constructor(private props: IScore) {
    }
    
    get lifetime() {
        return this.props.lifetime;
    }

    set lifetime(value: number) {
        this.props.lifetime = value;
    }
}